export default {
  init() {

    $('.changepickup').click(function(e) {
      e.preventDefault();

      var button = $('button.selectDate[data-date="' + $(e.target).data('pickupdate') + '"]');
      button.addClass('selected').trigger('click');
      $('#popBookDate').val(button.data('show'));
      $('#popBookDate').data('date', button.data('date'));
      $('#popBookDate').data('pid', button.data('pid'));
      $('#popBookDate').trigger('change');

      loadTimes($(e.target).data('pickuptime'));
      $('#bookingPopUp').modal('show');

    });

    $('#bookingPopUp').on('show.bs.modal', function(){

      $('.selectDate').click(function(e){
        e.preventDefault();
        $('.selectDate').removeClass('selected');
        $(e.target).addClass('selected');
        $('#popBookDate').val($(this).data('show'));
        $('#popBookDate').data('date', $(this).data('date'));
        $('#popBookDate').trigger('change');
      });

      $('#popBookDate').change(loadTimes);
    });

    function loadTimes( selectTime='' ) {

      $('#popTimes').html('<div class="w-100 d-flex justify-content-center"><img src="/wp-content/themes/13thwinery/resources/assets/images/Rotatingrings.gif" style="width: 50px; height: 50px; margin: 5px auto;" /></div>');

      $.ajax('/wp-admin/admin-ajax.php', {
        method: 'post',
        data: {
          action: 'bookablepickuptimes',
          bookdate: $('#popBookDate').data('date'),
        },
        success: function(data){
          var timeshtml = '';
          $.each( data.times, function( index, time ) {
            timeshtml += '                        <button class="red-time-button" data-booktime="' + time.time + '">\n' +
              '                            <div class="time-option">\n' + time.show +
              '                            </div>\n' +
              '                            <div class="time-options-inc">\n' +
              '                                <img src="/wp-content/themes/13thwinery/resources/assets/images/Plus-white.svg" alt="" style="width: 36px; height: 36px;" />\n' +
              '                            </div>\n' +
              '                        </button>\n';
          });

          if( data.times.length == 0 )
            timeshtml = '<p>Sorry, we have <strong>no available pick up times</strong> on this date.</p>';

          $('#popTimes').html(timeshtml);

          if( selectTime )
            $('button.red-time-button[data-booktime="' + selectTime + '"]').addClass('selected');

          $('#popTimes button').click(function(e){
            e.preventDefault();
            $('button.red-time-button').removeClass('selected');
            $(e.target).addClass('selected');

            $.ajax('/wp-admin/admin-ajax.php', {
              method: 'post',
              data: {
                action: 'bookpickup',
                bookdate: $('#popBookDate').data('date'),
                booktime: $(this).data('booktime'),
                pid: $('#popBookDate').data('pid'),
              },
              success: function(){

                $('input.qty[type="number"]').trigger('change');
                // $('[name="update_cart"]').trigger('click');
                $('#bookingPopUp').modal('hide');
                // location.reload();
              },
            });
          });
        },
      });
    }

  },
  finalize() {
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/cart.js